
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Rewind = () => (
      <>
        <polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>
      </>
    );
    export default Rewind;
    